import React, { Fragment } from "react";
import {
  Icon,
  Paragraph,
  breakpoints,
  useMediaQuery,
  useColorTokens
} from "@tvg/design-system";
// Utils
import { orderBy } from "lodash";
import { formatPostTime, formatPeriod } from "@tvg/formatter/dates";
import {
  HorseChanges,
  JockeyChange,
  RaceTypeCodeEnum
} from "@tvg/ts-types/Race";
import { ChangeWrapper, Container, Row } from "./styled-components";

export interface RunnerChangesProps {
  changes?: HorseChanges | null;
  runnerNumber: string;
  raceTypeCode: RaceTypeCodeEnum;
}

const RunnerChanges: React.FC<RunnerChangesProps> = ({
  changes,
  runnerNumber,
  raceTypeCode
}) => {
  const colorTokens = useColorTokens();
  const isMobile = useMediaQuery(breakpoints.tablet.max.sm);
  const jockeyChanges: JockeyChange[] = changes?.jockey || [];
  const MobileRow = isMobile ? Row : Fragment;

  return (
    <Container>
      {orderBy(jockeyChanges, ["date"], ["desc"]).map((change: JockeyChange) =>
        change.runnerId === runnerNumber ? (
          <ChangeWrapper key={change.runnerId}>
            <Paragraph qaLabel="change-jockey">
              <>
                <Paragraph
                  qaLabel="change-date"
                  mr="4"
                  color={colorTokens.content.subtle}
                >
                  <>
                    {formatPostTime(change.date)} {formatPeriod(change.date)}
                  </>
                </Paragraph>
                <Paragraph
                  qaLabel="text-keyword"
                  mr="space-5"
                  fontWeight="600"
                  color={colorTokens.content.subtle}
                >
                  {raceTypeCode === RaceTypeCodeEnum.HARNESS
                    ? "Driver"
                    : "Jockey"}
                </Paragraph>
                <MobileRow
                  data-qa-label={isMobile ? "old-new-value-container" : null}
                >
                  <Paragraph
                    qaLabel="text-setTo"
                    color={colorTokens.content.subtle}
                  >
                    {change.oldValue || "Set to\u00A0"}
                  </Paragraph>
                  {change.oldValue && change.newValue ? (
                    <Icon
                      name="arrowRight"
                      size="s"
                      mr="space-1"
                      ml="space-1"
                      qaLabel={`changes-jockey-value-icon-${change.runnerId}`}
                    />
                  ) : null}
                  <Paragraph
                    qaLabel="text-change-newValue"
                    color="orange.800"
                    fontWeight="600"
                  >
                    {change.newValue}
                  </Paragraph>
                </MobileRow>
              </>
            </Paragraph>
          </ChangeWrapper>
        ) : null
      )}
    </Container>
  );
};

export default RunnerChanges;
